var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlympics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 9.5,
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 49.25,
    stroke: "#0081c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 54,
    r: 49.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 54,
    r: 49.25,
    stroke: "#ee334e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 104,
    r: 49.25,
    stroke: "#fcb131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.5,
    cy: 104,
    r: 49.25,
    stroke: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4 24.45a49.25 49.25 0 010 59.1",
    stroke: "#0081c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 24.45a49.25 49.25 0 010 59.1m-39.4 19.7a49.25 49.25 0 01-29.55-9.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 103.25a49.25 49.25 0 01-29.55-9.85",
    stroke: "#ee334e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympics);
export default __webpack_public_path__ + "static/media/olympics.c76d2eb7e5cecb9a444cd663484d4ab0.svg";
export { ForwardRef as ReactComponent };